module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATBAMAAACAfiv/AAAAFVBMVEWgoKBHcEygoKChoaGgoKCfn5+goKAwfE3eAAAAB3RSTlNuAGAPTTUgrqFGFgAAAINJREFUCNdNz00KgzAQBeBH0K4zxO7T6gFUxLUtPUD6c4Biev8z9M1EwWzy8RgmLxAJv/sji3iIvAC4p7KBnkq5GHHzOBeh9hg3okey201EGW1XIlo4g4gVp9uv0eWoIbngNGpIJLisIdFzeyp7D6+FrcOFdabSbNj7wvpK+Fy7N3/xBxO0DvuBl0IGAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/gou_no.png
// module id = xyhl
// module chunks = 1